var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full h-full flex items-center justify-center relative"},[_c('div',{staticClass:"spin-loader mx-auto",attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('p',{staticClass:"font-medium absolute ml-2"},[_vm._v(_vm._s(_vm.progress)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }